module.exports = "/desktop-app/assets/img/wallet.svg?d6e25c7f878d6aec40475a518ad3d5fa";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/wallet.svg
// module id = evfQ
// module chunks = 1